import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VTooltip,
    {
      attrs: { top: "", "max-width": "500" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on: onTooltip }) {
            return [
              _c(
                VSelect,
                _vm._g(
                  {
                    attrs: {
                      items: _vm.anos,
                      label: _vm.label,
                      "prepend-icon": "edit_calendar",
                      rules: _vm.rules,
                      disabled: _vm.desabilitado,
                    },
                    model: {
                      value: _vm.anoSelecionado,
                      callback: function ($$v) {
                        _vm.anoSelecionado = $$v
                      },
                      expression: "anoSelecionado",
                    },
                  },
                  { ...onTooltip }
                )
              ),
            ]
          },
        },
      ]),
    },
    [_c("span", [_vm._v(_vm._s(_vm.tooltip))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }